import GearSvg from '../../assets/svg/gear.svg';
export default GearSvg;
